import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import fetchMileageRates from './useMileageRates.request';
import { UseMileageRatesResponse } from './useMileageRates.interface';

const useMileageRates = (options?: UseQueryOptions<UseMileageRatesResponse>) => {
    return useQuery({
        queryKey: ['bookkeeping', 'useMileageRates'],
        queryFn: fetchMileageRates,
        retry: false,
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        ...options,
    });
};

export default useMileageRates;
